module.exports = __webpack_public_path__ + "static/media/RGB.afce5adb.png";